export const YesOrNoOptions = [
  {
    label: '是',
    value: 1,
    color: 'red',
  },
  {
    label: '否',
    value: 2,
    color: 'blue',
  },
];
